
import React, { useState, useEffect } from 'react';
import { X, PlusCircle, Gift } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useNavigate } from 'react-router-dom';

const WelcomePopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if popup was already shown in this session
    const hasSeenWelcome = sessionStorage.getItem('welcome_popup_shown');
    
    if (!hasSeenWelcome) {
      // Show popup after a short delay
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('welcome_popup_shown', 'true');
  };

  const handleCreateListing = () => {
    handleClose();
    navigate('/create-listing');
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md mx-4">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl font-bold text-center">
            <Gift className="text-green-600" size={24} />
            Mirë se vini në TreguIm!
          </DialogTitle>
        </DialogHeader>
        
        <div className="text-center py-4">
          <div className="mb-6">
            <div className="bg-green-100 rounded-full p-4 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
              <PlusCircle className="text-green-600" size={32} />
            </div>
            
            <h3 className="text-lg font-semibold mb-2">
              Postoni FALAS!
            </h3>
            
            <p className="text-gray-600 mb-4">
              Krijoni shpalljen tuaj të parë krejtësisht falas dhe arrini mijëra blerës të mundshëm në të gjithë Shqipërinë.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
              <p className="text-sm text-yellow-800 font-medium">
                🎉 Shpallje të pa kufizuara - 100% FALAS!
              </p>
            </div>
          </div>
          
          <div className="space-y-3">
            <Button 
              onClick={handleCreateListing}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 rounded-lg"
              size="lg"
            >
              <PlusCircle size={20} className="mr-2" />
              Krijo Shpallje Falas
            </Button>
            
            <Button 
              onClick={handleClose}
              variant="outline" 
              className="w-full"
            >
              Më vonë
            </Button>
          </div>
        </div>
        
        <button
          onClick={handleClose}
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomePopup;
